// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"OLeOGzo0"};